import React from "react";
import {
  greyColor49,
  lightRedColor02,
  outOfStockColor,
} from "../../../configs/styles/muiThemes";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";

const NotSellingWarningCard = ({ notSellingCount }) => {
  return (
    <Box
      sx={{
        bgcolor: lightRedColor02,
        p: "6px 10px",
        borderRadius: "8px",
        m: "10px 0 5px 0",
      }}
    >
      <Typography
        fontSize={{ xs: 12, md: 12 }}
        fontWeight={500}
        color={outOfStockColor}
        lineHeight="21px"
      >
        Currently, {notSellingCount} products are not selling. Please enable
        availability in the 'Not Selling' tab to ensure these products are
        orderable. {" "}
        <Link
          to={`/${sessionStorage.getItem("costboWEBURL")}/pausedInventory`}
          style={{
            color: greyColor49,
            textDecoration: "underline",
          }}
        >
          Click Here
        </Link>
      </Typography>
    </Box>
  );
};

export default NotSellingWarningCard;
